import React from "react";

interface Props {
  children: React.ReactNode;
  /** 어떤 화면에서 난 오류인지 로그/표시에 쓴다 */
  label?: string;
}

interface State {
  error: Error | null;
}

/**
 * 화면 하나에서 난 오류가 앱 전체를 내리지 않도록 막는 경계.
 *
 * 경계가 없으면 단위화면의 렌더/effect 예외가 그대로 루트까지 올라가
 * 레이아웃째로 언마운트된다. 그러면 사용자는 새로고침 말고는 방법이 없고,
 * 열려 있던 다른 탭에서 입력 중이던 내용까지 함께 날아간다.
 */
export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(
      `화면 오류${this.props.label ? `(${this.props.label})` : ""}:`,
      error,
      info.componentStack
    );
  }

  handleRetry = () => this.setState({ error: null });

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          color: "#444",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <div style={{ fontWeight: "bold" }}>
          화면을 표시하는 중 오류가 발생했습니다.
        </div>
        <div style={{ fontSize: "12px", color: "#888", wordBreak: "break-all" }}>
          {error.message}
        </div>
        <button
          type="button"
          onClick={this.handleRetry}
          style={{
            marginTop: "8px",
            padding: "6px 16px",
            border: "1px solid #bfc4cc",
            borderRadius: "4px",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          다시 시도
        </button>
        <div style={{ fontSize: "12px", color: "#888" }}>
          다른 탭은 그대로 열려 있습니다. 새로고침하지 않아도 됩니다.
        </div>
      </div>
    );
  }
}
